module.exports = __webpack_public_path__ + "static/img/partner_8.223cf32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/partners/partner_8.png
// module id = bK8i
// module chunks = 0